import { StackHeaderMode } from '@react-navigation/stack/lib/typescript/src/types';
import { StackNavigationOptions } from '@react-navigation/stack';
import { useDefaultStackScreenOptions } from './use-default-stack-screen-options';
import { useMemo } from 'react';

export const useDefaultAppTabScreenOptions = (headerMode?: StackHeaderMode) => {
  const defaultOptions = useDefaultStackScreenOptions();
  return useMemo<StackNavigationOptions>(() => {
    return {
      ...defaultOptions,
      ...(headerMode ? { headerMode } : null),
    };
  }, [defaultOptions, headerMode]);
};
